"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegalFSShort = void 0;
var LegalFSShort = /** @class */ (function () {
    function LegalFSShort() {
        this.legalText = 'Free shipping<br>\n';
        this.shortLegalLinkLabel = 'See details';
    }
    return LegalFSShort;
}());
exports.LegalFSShort = LegalFSShort;
//# sourceMappingURL=legalFSshort.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/DeliveryInfoWLS/legalFSshort.cms.js
// module id = 1992
// module chunks = 8